import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";

import { CloseIcon, PenMenuIcon } from "../../Icons";
import {
  setEmployeesDialogParams,
  showEmployeesDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";
import { StudioWorkingTime } from "../StudioWorkingTime";

export const RightEmployeeDrawer = () => {
  const dispatch = useDispatch();

  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);
  const { studios: studiosToCompare } = useSelector(
    (state: any) => state.studios
  );

  const studiosToDisplay = studiosToCompare.filter((studio: any) => {
    return rowData.studios?.some(
      (rowStudio: { id: any }) => rowStudio.id === studio.id
    );
  });

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 2,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setEmployeesDialogParams(getBasicEditParams()));
      dispatch(showEmployeesDialog());
    }, 100);
  };

  const handleEditBasicInfoButton = () => {
    handleClose();
    dispatch(setEmployeesDialogParams(getBasicEditParams()));
    dispatch(showEmployeesDialog());
  };

  const handleEditAssignSkillsServicesButton = () => {
    handleClose();
    dispatch(
      setEmployeesDialogParams({
        ...getBasicEditParams(),
        step: 2,
      })
    );
    dispatch(showEmployeesDialog());
  };

  const handleEditAssignWorkingTimeButton = () => {
    handleClose();
    dispatch(
      setEmployeesDialogParams({
        ...getBasicEditParams(),
        step: 1,
      })
    );
    dispatch(showEmployeesDialog());
  };

  return (
    <Box
      sx={{
        position: "fixed",
        width: "424px",
        height: "auto",
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        top: 82,
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            About employee
          </Typography>
        </Box>
        <Button
          sx={{
            fontSize: "14px",
            fontWeight: "400",
          }}
          onClick={handleEditAllButton}
          disableRipple
        >
          Edit all
        </Button>
      </Box>

      <Box
        sx={{
          height: "calc(100vh - 82px - 62px)",
          overflowY: "auto",
        }}
      >
        <Box
          display="flex"
          sx={{
            padding: "16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Basic information
              </Typography>

              <IconButton
                onClick={handleEditBasicInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              sx={{
                flex: 1,
                marginBottom: "16px",
              }}
            >
              <Avatar
                src={rowData.photo}
                sx={{
                  width: "104px",
                  height: "104px",
                  borderRadius: "12px",
                  marginRight: "16px",
                }}
              />

              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{
                  height: "100%",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      color: "#828282",
                    }}
                  >
                    id
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#080808",
                    }}
                  >
                    {rowData.id}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      color: "#828282",
                    }}
                  >
                    Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#080808",
                    }}
                  >{`${rowData.firstName} ${rowData.lastName}`}</Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "60%",
                }}
              >
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    color: "#828282",
                  }}
                >
                  Email
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {rowData.email}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "40%",
                }}
              >
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    color: "#828282",
                  }}
                >
                  Studio
                </Typography>
                {rowData?.studios?.map((studio: any) => (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#080808",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {studio.title}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Skills
              </Typography>

              <IconButton
                onClick={handleEditAssignSkillsServicesButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>
            <Box>
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontSize: "12px",
                  color: "#828282",
                }}
              >
                    Skill name
              </Typography>
              {rowData.skills && rowData.skills.map((skill: any) => (
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >
                  {skill.specialty}
                </Typography>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Services
              </Typography>

              <IconButton
                onClick={handleEditAssignSkillsServicesButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            {rowData.skills &&
              rowData.skills.map((serviceSkill: any, index: number) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    padding: "8px 0 8px",
                    borderBottom: index !== rowData.skills.length - 1 ? "1px solid #F3F3F3" : "",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flex: "60%",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontSize: "12px",
                        color: "#828282",
                      }}
                    >
                      Service
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#080808",
                      }}
                    >
                      {serviceSkill?.service?.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flex: "40%",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontSize: "12px",
                        color: "#828282",
                      }}
                    >
                      Rank
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#080808",
                      }}
                    >
                      {serviceSkill?.rank}
                    </Typography>
                  </Box>
                </Box>
              ))}
          </Box>
        </Box>

        <Box
          display="flex"
          sx={{
            padding: "0 16px 16px",
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              backgroundColor: "white",
              flex: 1,
              borderRadius: "6px",
              padding: "16px 16px 24px",
              boxShadow: "0px 4px 16px 0px rgba(41, 66, 90, 0.12)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                flex: 1,
                marginBottom: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Working time
              </Typography>

              <IconButton
                onClick={handleEditAssignWorkingTimeButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            </Box>

            {rowData.studios ?
              rowData.studios.map((studio: any) => (
                <StudioWorkingTime
                  inDrawer
                  renderImage={false}
                  key={studio.id}
                  studio={studio}
                  workingTime={studio?.masterSchedule?.workingTimes?.[0]}
                  customStyle={{
                    borderRadius: "6px",
                    maxWidth: "354px"
                  }}
                />)) :
              studiosToDisplay?.map((studio: any) => (
                <StudioWorkingTime
                  inDrawer
                  renderImage={false}
                  key={studio.id}
                  studio={studio}
                  workingTime={studio?.masterSchedule?.workingTimes?.[0]}
                  customStyle={{
                    borderRadius: "6px",
                    maxWidth: "354px"
                  }}
                />
              ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
